'use es6';

import { useCallback } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import unescapedText from 'I18n/utils/unescapedText';
import LanguageSelect from 'ui-addon-i18n/components/LanguageSelect';
import { CUSTOMER_SUPPORT_LANGUAGES as validLanguages } from 'marketplace-ui-common/constants/Languages';
import { jsx as _jsx } from "react/jsx-runtime";
const AppLanguagesSelect = ({
  onChange,
  value
}) => {
  const handleChange = useCallback(({
    target: {
      value: selectValue
    }
  }) => {
    onChange(Immutable.Set(selectValue));
  }, [onChange]);
  return /*#__PURE__*/_jsx(LanguageSelect, {
    clearable: true,
    multi: true,
    onChange: handleChange,
    placeholder: unescapedText('appMarketplace.storefront.filters.appLanguages.selectPlaceholder'),
    validLanguages: validLanguages,
    value: value.toArray()
  });
};
AppLanguagesSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: ImmutablePropTypes.iterableOf(PropTypes.oneOf(validLanguages)).isRequired
};
export default AppLanguagesSelect;